var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M-8686-33.065a1.1,1.1,0,0,1,.327-.774l6.151-6.17-6.151-6.151a1.119,1.119,0,0,1-.327-.776A1.051,1.051,0,0,1-8684.954-48a1,1,0,0,1,.729.305l6.223,6.239,6.224-6.239a.986.986,0,0,1,.727-.305A1.051,1.051,0,0,1-8670-46.935a1.126,1.126,0,0,1-.325.776l-6.151,6.151,6.151,6.168a1.107,1.107,0,0,1,.325.776A1.051,1.051,0,0,1-8671.052-32a.986.986,0,0,1-.727-.305L-8678-38.553l-6.223,6.247a.993.993,0,0,1-.729.307A1.052,1.052,0,0,1-8686-33.065Z",
    transform: "translate(8686.503 48.499)",
    fill: "#788e9f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.2bec3952b4a5fd61a6a45ee089fe30be.svg";
export { ForwardRef as ReactComponent };